import { render, staticRenderFns } from "./bread.vue?vue&type=template&id=015b6cfc"
import script from "./bread.vue?vue&type=script&lang=js"
export * from "./bread.vue?vue&type=script&lang=js"
import style0 from "./bread.vue?vue&type=style&index=0&id=015b6cfc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports